import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAssistant } from '@/contexts/AssistantContext';

// /assistant was the chat as a full page until the header's Agent popup
// became the way in (23eca18b). Nothing links to it any more, and on it the
// Agent button opened the popup over the page's own chat: two inputs for one
// conversation. An old bookmark now opens the popup on the dashboard.
const OpenAssistantRedirect = () => {
  const { openAssistant } = useAssistant();
  useEffect(() => {
    openAssistant();
  }, [openAssistant]);
  return <Navigate to="/dashboard-home" replace />;
};

export default OpenAssistantRedirect;
